import {
  SET_LOADING_SITES,
  LOAD_SITES_SUCCESS,
  LOAD_SITES_ERROR,
  ATTACH_SITE,
} from "../actions/customer";

const customerInitialState = {
  sites: [],
  loadingSites: false,
  selectedSite: null,
  error: null,
};

const customerReducer = (state = customerInitialState, action) => {
  switch (action.type) {
    case "RESET_STORE":
    case "LOGOUT_STORE":
      return {
        ...customerInitialState,
      };
    case SET_LOADING_SITES:
      return {
        ...state,
        loadingSites: true,
        error: null,
      };
    case LOAD_SITES_SUCCESS:
      return {
        ...state,
        loadingSites: false,
        sites: action.payload.sites,
      };
    case LOAD_SITES_ERROR:
      return {
        ...state,
        loadingSites: false,
        sites: [],
        error: action.payload.error,
      };
    case ATTACH_SITE:
      return {
        ...state,
        selectedSite: action.payload.selectedSite,
      };
    default:
      return state;
  }
};

export default customerReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/customer.js